import { bespokeTenants } from '@debbie/common/dist/bespoke/index.js';
import { TribunalCaseType, tribunalCaseTypesByCountry, } from '@debbie/common/dist/tribunal/cases/types.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Select from '../../Select.js';
import Well from '../../Well.js';
import AndreFogedsager from './types/AndreFogedsager.js';
import Fogedbegaering from './types/Fogedbegaering.js';
import { Betalingspaakrav, Fogedrekvisition, GLBetalingspaakrav, } from './types/index.js';
import Staevning from './types/Staevning.js';
const CreateTribunalCase = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    let caseTypes = tenant ? tribunalCaseTypesByCountry[tenant.countryCode] : [];
    if (caseTypes && props.tenantId === bespokeTenants.mortangProd) {
        caseTypes = [...caseTypes, TribunalCaseType.GLBetalingspaakrav];
    }
    const [type, _setType] = useState(caseTypes ? caseTypes[0] : null);
    const setType = (t) => {
        _setType(t);
        localStorage.setItem('tribunalCaseTypeDefault', t);
    };
    useEffect(() => {
        if (caseTypes) {
            const defaultType = localStorage.getItem('tribunalCaseTypeDefault');
            if (defaultType && caseTypes.includes(defaultType)) {
                _setType(defaultType);
            }
        }
    }, [caseTypes]);
    if (!tenant) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement(Select, { value: type, onChange: (e) => setType(e.target.value) }, caseTypes.map((t) => (React.createElement("option", { key: t, value: t }, lang.tribunalCaseTypes[t])))),
        React.createElement(Well, null,
            type === TribunalCaseType.DKBetalingspaakrav && (React.createElement(Betalingspaakrav, { caseId: props.caseId, caseSeqId: props.caseSeqId, tenantId: props.tenantId, onCreated: props.onCreated })),
            type === TribunalCaseType.DKFogedrekvisition && (React.createElement(Fogedrekvisition, { caseId: props.caseId, caseSeqId: props.caseSeqId, tenantId: props.tenantId, onCreated: props.onCreated })),
            type === TribunalCaseType.DKAndreFogedsager && (React.createElement(AndreFogedsager, { caseId: props.caseId, caseSeqId: props.caseSeqId, tenantId: props.tenantId, onCreated: props.onCreated })),
            type === TribunalCaseType.GLStaevning && (React.createElement(React.Fragment, null,
                React.createElement(Staevning, { caseId: props.caseId, caseSequentialId: props.caseSeqId, tenantId: props.tenantId, onCreated: props.onCreated }))),
            type === TribunalCaseType.GLFogedBegaering && (React.createElement(React.Fragment, null,
                React.createElement(Fogedbegaering, { caseId: props.caseId, caseSequentialId: props.caseSeqId, tenantId: props.tenantId, onCreated: props.onCreated }))),
            type === TribunalCaseType.GLBetalingspaakrav && (React.createElement(GLBetalingspaakrav, { caseId: props.caseId, caseSeqId: props.caseSeqId, tenantId: props.tenantId, onCreated: props.onCreated })))));
};
export default CreateTribunalCase;
//# sourceMappingURL=CreateTribunalCase.js.map